export default () => ({
  headSection: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '1rem',
  },
})
